
import { computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useWebStore } from '../stores/web';

// Manager-driven homepage promotion grid. Renders the operator-curated
// promotion list (managerConfig.promotions — already filtered to active and
// sorted by sortOrder ascending by the API) as a banner grid of image links.
//
// Precedence: manager wins. When the manager has no promotions (or is
// unreachable), the component renders nothing and the static PHP grid
// (#promotion-fallback) stays visible — preserving the theme's prior behavior.
export default {
	name: 'PromotionGrid',
	setup() {
		const web = useWebStore();
		web.hydrate();
		web.fetchManagerConfig();
		const { managerConfig } = storeToRefs(web);

		const promotions = computed(() => managerConfig.value?.promotions ?? []);
		const hasPromotions = computed(() => promotions.value.length > 0);

		// Hide the static PHP fallback grid once the manager provides its own
		// list, so the two never render at once. Re-runs when the config loads.
		const syncFallback = () => {
			const el = document.getElementById('promotion-fallback');
			if (el) el.style.display = hasPromotions.value ? 'none' : '';
		};
		onMounted(syncFallback);
		watch(hasPromotions, syncFallback);

		return { promotions, hasPromotions };
	},
};
